import { Box, makeStyles, useTheme } from '@material-ui/core';
import Link from 'next/link';
import { useState } from 'react';
import { useMobile } from 'hooks';
import { Typography } from 'design-system/atoms';
import { useRouter } from 'next/router';
import { useEventsTracker } from 'hooks/events-tracker/useEventsTracker';
import { ContentItemButton } from '../types/ContentItemButton';

const useStyles = makeStyles(() => ({
  navButtonContentItemRoot: {
    display: 'flex',
    height: '100%',
    cursor: 'pointer',
    textDecoration: 'none',
  },
}));

function VerticalBar({ isActive }: { isActive: boolean }) {
  const theme = useTheme();
  const isMobile = useMobile();

  return (
    <Box
      marginRight={2}
      width={6}
      borderRadius={8}
      height="100%"
      bgcolor={
        isActive || isMobile
          ? theme.palette.primary.main
          : theme.palette.grey[200]
      }
    />
  );
}

interface IProps extends ContentItemButton {
  currentPath: string;
}

function NavbarSubItem({
  label,
  description,
  path,
  dataQa,
  trackEvent,
  currentPath,
}: IProps) {
  const classes = useStyles();
  const isActive = currentPath.includes(path);
  const [isHover, setIsHover] = useState(false);
  const router = useRouter();
  const eventsTracker = useEventsTracker();

  const onClick = () => {
    if (trackEvent !== undefined) {
      const { pathname: source } = router;
      eventsTracker.sendEvent(trackEvent, { source });
    }
  };

  return (
    <Link href={path} passHref data-qa={dataQa}>
      <Box
        className={classes.navButtonContentItemRoot}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        component="a"
        minWidth={350}
        onClick={onClick}
      >
        <VerticalBar isActive={isActive || isHover} />

        <div>
          <Typography
            variant="body1"
            color={isActive || isHover ? 'primary' : 'textPrimary'}
            gutterBottom
            component="div"
          >
            <Box fontWeight="fontWeightMedium">{label}</Box>
          </Typography>
          <Typography variant="body3" color="textSecondary">
            {description}
          </Typography>
        </div>
      </Box>
    </Link>
  );
}

export default NavbarSubItem;
